import moment from 'moment-timezone';
import { v4 as uuidV4 } from 'uuid';
import { get, isEmpty, uniqueId, compact, find, isNil, isNull } from 'lodash';
import { FEATURES } from 'features/features';
import {
  checkUniqCinVictim,
  isMinorVictim,
} from 'containers/PreOpeningPage/utils';
import {
  OPEN_CLAIM_CONSTANTS,
  MOROCCO_COUNTRY_CODE,
  MATERIAL,
  CORPOREAL_SAGIS,
  OTHER_REASON_ID,
  ManagerToTownCode,
  DEFAULT_LAWYER_CODE,
  MANAGEMENT_MODES,
} from 'containers/RecapManagerPage/constants';
import {
  CLAIM,
  VEHICULE,
  DRIVER,
  VALIDATION_DECISION,
  VICTIM,
  REJECTION_DECISION,
  PARTIES_CLAIM_STATUS,
  PROCEDURE_STATUSES,
  LISTINGS,
  BENEFICIARY,
} from 'containers/data-structure';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { CLAIM_STATUS } from 'containers/data-structure';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { translate } from 'containers/services/translate';
import messages from 'containers/RecapManagerPage/messages';
import { CodesConfig, SagisConfig } from 'containers/AppContainer/typings';
import {
  appConfigListingTyping,
  BeneficiaryType,
  VictimType,
} from 'typings/globalTypes';
import {
  Assignees,
  AssignmentClaim,
  AssignPayload,
  KeycloakUser,
} from 'containers/RecapManagerPage/typings';
import { hasFeature } from 'features/fflip-helpers';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import * as featureService from 'features/fflip-helpers';
import { CLAIM_STATUS_SAGIS } from 'containers/RecapManagerPage/constants';
import {
  CHOICE,
  INJURY_POST_DECEASED,
} from 'containers/PreOpeningPage/constants';
import { PROCEDURE_STEPS } from 'containers/LawyerFeeNote/constants';
import { extractIntervenantType } from 'containers/RecapPage/utils';
import {
  DEFAULT_SUB_SERVICE_ID,
  PROFESSION_CODES,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import {
  DEFAULT_INTERVENANT_CODE,
  DEFAULT_PROVIDER_CODE,
  HOLDER_PV_OTHER,
  HOLDER_PV_PROVIDER,
  PROFIL_OPENNER_GPO,
} from 'containers/RecapPage/canstants';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import {
  addPriorityReasonProfession,
  removeDeletedItems,
  removeWhiteSpaceFromString,
} from 'services/utils';
import { CLAIM_TYPE } from 'containers/IdentificationPage/SearchResults/ClaimWithNotIndexedPV/constants';
import { OPENING_STATE, OPENING_TYPE } from 'services/constants';
import { ClaimType } from 'typings/claimTypes';
import { resolveSagisClaim } from 'helpers/utils';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/constants';
import { formatOpposingParties } from 'containers/CourtManagerLegalProceedings/utils';

export const constructFeeNoteProvision = (
  claim: any,
  feeNotePV: any,
  providerListing: any,
  LawyerName: any,
  listings: any,
) => {
  return get(claim, 'profilOpenner', '') === PROFIL_OPENNER_GPO
    ? get(claim, 'pvHolder.pvHolderTypeId', null) === HOLDER_PV_PROVIDER
      ? {
          InterKey: get(feeNotePV, 'codeIntervenant'),
          Name: get(providerListing, 'ItemDescription', ''),
          TypeCde: DEFAULT_PROVIDER_CODE,
          ReasonCode: '2',
          Amount: Number(200),
        }
      : get(claim, 'pvHolder.pvHolderTypeId', null) === HOLDER_PV_OTHER
      ? {
          InterKey: claim.codeLawyer,
          Name: get(LawyerName, 'ItemDescription', ''),
          TypeCde: extractIntervenantType(
            listings,
            get(claim, 'intervenantTypeCode'),
          ),
          ReasonCode: '2',
          Amount: 0,
        }
      : {
          InterKey: claim.codeLawyer,
          Name: get(LawyerName, 'ItemDescription', ''),
          TypeCde: extractIntervenantType(
            listings,
            get(claim, 'intervenantTypeCode'),
          ),
          ReasonCode: '2',
          Amount:
            !featureService.hasFeature(FEATURES.OPENING_BY_USAGE) &&
            get(claim, 'openingType') === OPENING_TYPE.NORMAL
              ? claim.codeLawyer === DEFAULT_LAWYER_CODE
                ? Number(3020)
                : Number(3220)
              : Number(200),
        }
    : {
        InterKey: claim.codeLawyer,
        Name: get(LawyerName, 'ItemDescription', ''),
        TypeCde: extractIntervenantType(
          listings,
          get(claim, 'intervenantTypeCode'),
        ),
        ReasonCode: '2',
        Amount:
          claim.codeLawyer === DEFAULT_LAWYER_CODE
            ? Number(3020)
            : Number(3220),
      };
};

export const formatClaimToOpen = (
  claimDetails: any,
  openingDetails: any,
  claims: any,
  listings: any,
  isSuspicious: string,
  priorityReasonClaimId: number | null = null,
  openClaimWithoutSagis: boolean = false,
) => {
  const {
    claim,
    victims,
    vehicules,
    driver,
    documents,
    deletedDocuments,
    deletedVictims,
  } = claimDetails;

  const updatePriorityVictim =
    !removeDeletedItems(victims).find((v: any) =>
      PROFESSION_CODES.includes(v.professionCode),
    ) && priorityReasonClaimId === 5;
  const LawyerName = find(
    get(listings, 'intervenants'),
    (element: { ItemKey: any }) => element.ItemKey === claim.codeLawyer,
  );
  const resp = find(
    get(listings, 'responsability'),
    (element: { ItemKey: any }) =>
      element.ItemKey === openingDetails[VALIDATION_DECISION.RESPONSIBILITY],
  );
  const responsibility =
    openingDetails[VALIDATION_DECISION.MANAGEMENT_MODE] === '2'
      ? claim[CLAIM.RESPONSABILITY_SHARE]
      : get(resp, 'ItemDescription', claim[CLAIM.RESPONSABILITY_SHARE]);
  let otherDriver = driver;
  let formattedVehicule = [];
  let formattedOpposingParties = [];

  if (!isEmpty(driver)) {
    otherDriver = {
      ...driver,
      isDriverTheInsured:
        get(driver, 'isDriverTheInsured') === CHOICE.NO
          ? false
          : Boolean(get(driver, 'isDriverTheInsured')),
      driverFirstName: get(driver, [DRIVER.FIRST_NAME], ''),
      driverLastName: get(driver, [DRIVER.LAST_NAME], ''),
      driverLicenceDate: get(driver, [DRIVER.LICENSE_START_DATE], null),
      driverLicenceNumber: get(driver, [DRIVER.LICENSE_ID], null),
    };
  }

  if (hasFeature(FEATURES.OPPOSING_PARTY)) {
    formattedOpposingParties = removeDeletedItems(
      vehicules,
    ).map((vehicule: Vehicule) =>
      openingHelper.formatSagisVehiculeObject(vehicule),
    );
    formattedVehicule = vehicules;
  }

  const formattedVictims = victims.map((victim: VictimType) => {
    const getDescriptionByCode = (code: number | string, list: any) => {
      const item = get(list, 'classVictim').find(
        (item: any) => Number(item.ItemKey) === Number(code),
      );
      return item ? item.ItemDescription : '';
    };
    let setDefaultBirthDate = false;

    if (isEmpty(victim[VICTIM.DATE_OF_BIRTH])) {
      setDefaultBirthDate = true;
    }
    const commonVictim: any = {
      victimFirstName: victim[VICTIM.FIRST_NAME],
      victimLastName: victim[VICTIM.LAST_NAME],
      victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
      injuryCode:
        String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
          ? victim[VICTIM.INJURY_POST_KEY]
          : 0,
      qualityVictim: victim[VICTIM.QUALITY_KEY],
      classVictim: victim[VICTIM.CLASS_KEY],
      classVictimDescription: getDescriptionByCode(
        victim[VICTIM.CLASS_KEY],
        listings,
      ),
      cspCode: get(
        get(listings, 'Profession', []).find(
          (el: any) => el.ItemKey === victim.professionCode,
        ),
        'ItemGroup',
        null,
      ),
      annualInCome:
        ((victim.annualOfIncome as unknown) as string) === ''
          ? undefined
          : victim.annualOfIncome,
      annualOfIncome:
        ((victim.annualOfIncome as unknown) as string) === ''
          ? null
          : victim.annualOfIncome,
      Town: victim[VICTIM.CITY],
      Complement: victim[VICTIM.ADDRESS],
      isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1,
      setDefaultBirthDate,
      itt: parseFloat((victim[VICTIM.ITT] as unknown) as string),
      gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
      numberOfSpouse: victim[VICTIM.NUMBER_OF_SPOUSE],
    };
    if (victim.injuryPostKey === INJURY_POST_DECEASED) {
      victim.nextOfKins = victim.beneficiaries.map((el: any) => {
        return {
          fullName: `${removeWhiteSpaceFromString(
            el.firstName,
          )} ${removeWhiteSpaceFromString(el.lastName)}`,
          qualityCode: Number(el.beneficiaryType),
          age: el.age,
          birthDate: el?.dateOfBirth,
          funeralFees: featureService.hasFeature(FEATURES.NEW_LAW_DAHIR)
            ? el.funeralFees
            : !isNil(el.funeralFees) && !!Number(responsibility)
            ? el.funeralFees / (Number(responsibility) / 100)
            : el.funeralFees,
          handicapIndicator: el.handicapIndicator ? 'Y' : 'N',
          dependentIndicator: el.dependentIndicator ? 'Y' : 'N',
        };
      });
      delete commonVictim.itt;
      delete (victim as any).itt;
    } else {
      delete (victim as any).beneficiaries;
    }

    return {
      ...victim,
      ...commonVictim,
    };
  });

  const managerAssignedCode = resolveAssignedManager(
    get(claimDetails, 'claim.lossLocation', ''),
    get(claimDetails, 'claim.lossDate', ''),
  );

  const date = new Date(get(claimDetails, 'claim.lossDate'));
  const dayOfMonth = date.getDate();

  const lawyerJurisdictionAssignedCode = getAssignedJurisdictionLawyerCode(
    get(listings, LISTINGS.MAPPING_LAWYER_JURISDICTION, []),
    get(claimDetails, 'claim.jurisdictionId'),
    dayOfMonth,
  );
  const feeNotePV = get(claim, 'feeNotes', []).find(
    (el: any) => el.step === 'PV',
  );
  const providerListing = find(
    get(listings, 'intervenants'),
    (element: { ItemKey: any }) =>
      element.ItemKey === get(feeNotePV, 'codeIntervenant'),
  );
  return {
    ClaimNumber: !isEmpty(claims) ? claims.code : null,
    declarant: OPEN_CLAIM_CONSTANTS.DECLARANT_LAWYER_CODE,
    countryId: claim[CLAIM.COUNTRY_ID],
    receptionDate: moment().format('DD/MM/YYYY'),
    resp: responsibility,
    policyNumber: claim[CLAIM.POLICY_NUMBER],
    lossDate: moment(claim[CLAIM.LOSS_DATE]).format('DD/MM/YYYY'),
    lossTime: claim[CLAIM.LOSS_HOUR],
    placeOfOccurenceId: claim[CLAIM.LOSS_LOCATION],
    comments: openingDetails[VALIDATION_DECISION.COMMENT],
    withrisk: true,
    isFromCorporel: true,
    hasInjuredPeople: true,
    isPta: false,
    isMT: false,
    hasMaterialDamaged: false,
    procedureCode: '',
    isTransactionInboxesActive: featureService.hasFeature(
      FEATURES.INBOXES_TRANSACTION_MANAGER,
    ),
    pvNumber: claim[CLAIM.PV_NUMBER],
    isClosOrNoAction: isClaimClosOrNoAction(claims),
    priorityReasonId: addPriorityReasonProfession(
      null as any,
      !!removeDeletedItems(victims).find((v: any) =>
        PROFESSION_CODES.includes(v.professionCode),
      ),
      listings,
    )
      ? addPriorityReasonProfession(
          null as any,
          !!victims.find((v: any) =>
            PROFESSION_CODES.includes(v.professionCode),
          ),
          listings,
        )
      : updatePriorityVictim
      ? null
      : undefined,
    risques: [
      {
        claimKey: !isEmpty(claims) ? claims.code : null,
        scaleCaseCode: openingDetails[VALIDATION_DECISION.SCALE_CASE],
        circumstanceCode: openingDetails[VALIDATION_DECISION.CIRCUMSTANCE_CODE],
        circumstance: openingDetails[VALIDATION_DECISION.CIRCUMSTANCE],
        provisionHistory: [],
        riskId: '',
        managementMode: openingDetails[VALIDATION_DECISION.MANAGEMENT_MODE],
        responsabilityRate: openingDetails[VALIDATION_DECISION.RESPONSIBILITY],
        shouldSendNotification: false,
        victims: removeDeletedItems(formattedVictims),
        opposingParties: formattedOpposingParties,
        isFromCorporel: true,
        lossDate: !isEmpty(claims)
          ? moment(claim[CLAIM.LOSS_DATE]).format('DD/MM/YYYY') //changes-add-due-to-problem-of-provision-victim
          : undefined,
      },
    ],
    otherDriver: !isEmpty(otherDriver) ? otherDriver : undefined,
    vehicules: formattedVehicule,
    claim: {
      ...claim,
      suspicious: isSuspicious === CHOICE.YES ? true : false,
      isNatureChanged:
        openingDetails[VALIDATION_DECISION.CHANGE_NATURE] === CHOICE.YES,
      decidedAt: moment().format(),
      decidedBy: currentUserStorage.get()
        ? currentUserStorage.get().username.toLowerCase()
        : null,
      status: openClaimWithoutSagis
        ? CLAIM_STATUS.PENDING_APPROVAL
        : CLAIM_STATUS.VALIDATED,
      updatedBy: currentUserStorage.get()
        ? currentUserStorage.get().username.toLowerCase()
        : null,
    },
    openClaimWithoutSagis,
    documents,
    deletedDocuments,
    callAssignmentCorpo:
      get(claim, 'status', '') != CLAIM_STATUS.PENDING_APPROVAL,
    deletedVictims: !isEmpty(deletedVictims)
      ? [...deletedVictims].map((el: any) => ({
          ...el,
          itt: el?.itt === '' ? null : parseFloat(el[VICTIM.ITT]),
        }))
      : victims
          .filter((v: any) => v.isDeleted)
          .map((el: any) => ({
            ...el,
            itt: el?.itt === '' ? null : parseFloat(el[VICTIM.ITT]),
          })),
    fflipFeeNote: true,
    feeNote: {
      step: PROCEDURE_STEPS.PV,
      codeIntervenant:
        get(claim, 'profilOpenner', '') === PROFIL_OPENNER_GPO
          ? get(feeNotePV, 'codeIntervenant')
          : claim.codeLawyer,
    },
    feeNoteSagisProvision: constructFeeNoteProvision(
      claim,
      feeNotePV,
      providerListing,
      LawyerName,
      listings,
    ),
    isInboxesActive: featureService.hasFeature(
      FEATURES.ATTRIBUTION_INBOXES_MANAGER,
    ),
    isTrackingActive: featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER),
    lawyerJurisdictionAssignedCode,
    managerAssignedCode,
    isAutomaticLawyerAssignment: featureService.hasFeature(
      FEATURES.ASSIGNMENT_JURISDICTION_LAWYER,
    ),
    assignedManagerName: get(
      get(listings, LISTINGS.ASSIGNMENT_MANAGER, []).find(
        (el: any) => el.id === managerAssignedCode,
      ),
      'name',
      '',
    ),
    assignedLawyerName: getValueByCode(
      lawyerJurisdictionAssignedCode,
      get(listings, LISTINGS.STACKHOLDERS, []),
    ),
    claimId: get(claimDetails, 'claim.id'),
    intervenantTypeCode:
      get(claim, 'profilOpenner', '') === PROFIL_OPENNER_GPO
        ? get(claim, 'pvHolder.pvHolderTypeId', null) === HOLDER_PV_PROVIDER
          ? DEFAULT_PROVIDER_CODE
          : get(claimDetails, 'claim.intervenantTypeCode')
        : get(claimDetails, 'claim.intervenantTypeCode'),
    intervenantCode:
      get(claim, 'profilOpenner', '') === PROFIL_OPENNER_GPO
        ? get(feeNotePV, 'codeIntervenant')
        : get(claimDetails, 'claim.codeLawyer'),
    intervenantSagis: [
      {
        intervenantTypeCode: DEFAULT_INTERVENANT_CODE,
        intervenantCode: lawyerJurisdictionAssignedCode,
      },
    ],
    isLawyerInboxesActive: featureService.hasFeature(FEATURES.LAWYER_INBOXES),
    isCourtCalendarActive: featureService.hasFeature(FEATURES.COURT_CALENDAR),
  };
};

export const formatValidationCompletionClaim = (
  claimDetails: any,
  policyInfo: any,
  listings: any,
  priorityReasonClaimId: number | null = null,
) => {
  const {
    claim,
    victims,
    documents,
    driver,
    vehicules,
    opposingParty,
    fraudInfo,
  } = claimDetails;
  const updatePriorityVictim =
    !victims.find((v: any) => PROFESSION_CODES.includes(v.professionCode)) &&
    priorityReasonClaimId === 5;
  let formattedDriver = !isNil(driver) ? driver : {};
  let formattedVehicule = [...vehicules];
  const riskId =
    policyInfo &&
    get(resolveSagisClaim(policyInfo), 'offeredRisks', []).find(
      (element: { riskName: string }) => element.riskName === rcCoporeal,
    )?.riskId;
  const resp = find(
    get(listings, 'responsability'),
    (element: { ItemKey: any }) =>
      element.ItemKey === claim[VALIDATION_DECISION.RESPONSIBILITY],
  );
  const responsibility =
    claim[VALIDATION_DECISION.MANAGEMENT_MODE] === '2'
      ? claim[CLAIM.RESPONSABILITY_SHARE]
      : get(resp, 'ItemDescription', claim[CLAIM.RESPONSABILITY_SHARE]);

  if (get(driver, [DRIVER.IS_DRIVER_THE_INSURED]) === CHOICE.YES) {
    formattedDriver = {};
  }

  if (claim[CLAIM.HAS_MATERIAL_DAMAGES] === CHOICE.NO) {
    formattedVehicule = [];
  }

  if (claim[CLAIM.IS_JUDICIAL_PROCEDURE] === CHOICE.NO) {
    claim[CLAIM.JUDICIAL_PROCEDURE_ID] = null;
  }
  const formattedSagisVictims = victims
    .filter((v: any) => !v.isDeleted && (isNil(v.victimKey) || !v.id))
    .map((victim: VictimType) => {
      const getDescriptionByCode = (code: number | string, list: any) => {
        const item = get(list, 'classVictim').find(
          (item: any) => Number(item.ItemKey) === Number(code),
        );
        return item ? item.ItemDescription : '';
      };
      let setDefaultBirthDate = false;
      if (isEmpty(victim[VICTIM.DATE_OF_BIRTH])) {
        setDefaultBirthDate = true;
      }
      const commonVictim: any = {
        victimFirstName: victim[VICTIM.FIRST_NAME],
        victimLastName: victim[VICTIM.LAST_NAME],
        victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
        injuryCode:
          String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
            ? victim[VICTIM.INJURY_POST_KEY]
            : 0,
        qualityVictim: victim[VICTIM.QUALITY_KEY],
        classVictim: victim[VICTIM.CLASS_KEY],
        classVictimDescription: getDescriptionByCode(
          victim[VICTIM.CLASS_KEY],
          listings,
        ),
        cspCode: get(
          get(listings, 'Profession', []).find(
            (el: any) => el.ItemKey === victim.professionCode,
          ),
          'ItemGroup',
          null,
        ),
        gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
        annualInCome:
          ((victim.annualOfIncome as unknown) as string) === ''
            ? undefined
            : victim.annualOfIncome,
        annualOfIncome:
          ((victim.annualOfIncome as unknown) as string) === ''
            ? null
            : victim.annualOfIncome,
        Town: victim[VICTIM.CITY],
        Complement: victim[VICTIM.ADDRESS],
        isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1,
        setDefaultBirthDate,
        itt: parseInt((victim[VICTIM.ITT] as unknown) as string),
        numberOfSpouse: victim[VICTIM.NUMBER_OF_SPOUSE],
      };
      if (victim.injuryPostKey === INJURY_POST_DECEASED) {
        victim.nextOfKins = victim.beneficiaries.map((el: any) => {
          return {
            fullName: `${removeWhiteSpaceFromString(
              el.firstName,
            )} ${removeWhiteSpaceFromString(el.lastName)}`,
            qualityCode: Number(el.beneficiaryType),
            age: el.age,
            birthDate: el?.dateOfBirth,
            funeralFees: featureService.hasFeature(FEATURES.NEW_LAW_DAHIR)
              ? el.funeralFees
              : !isNil(el.funeralFees) && !!Number(responsibility)
              ? el.funeralFees / (Number(responsibility) / 100)
              : el.funeralFees,
            handicapIndicator: el.handicapIndicator ? 'Y' : 'N',
            dependentIndicator: el.dependentIndicator ? 'Y' : 'N',
          };
        });
        delete commonVictim.itt;
        delete (victim as Partial<VictimType>).itt;
      } else {
        delete (victim as Partial<VictimType>).beneficiaries;
      }

      return {
        ...victim,
        ...commonVictim,
        isLawyerInboxesActive: featureService.hasFeature(
          FEATURES.LAWYER_INBOXES,
        ),
      };
    });
  const formattedSagisVehiculesToUpdate = !isEmpty(vehicules)
    ? vehicules
        .filter((v: any) => v.isModified && v.id)
        .map((vehicule: any) => {
          return {
            ...vehicule,
            insuranceCompanyCode: vehicule?.opposingParty,
            partyKey: vehicule?.partyKey,
            riskID: riskId,
          };
        })
    : [];
  const formattedSagisVictimsToUpdate = victims
    .filter((v: any) => v.isModified && v.id)
    .map((victim: VictimType) => {
      let setDefaultBirthDate = false;
      if (isEmpty(victim[VICTIM.DATE_OF_BIRTH])) {
        setDefaultBirthDate = true;
      }
      return {
        ...victim,
        victimFirstName: victim[VICTIM.FIRST_NAME],
        victimLastName: victim[VICTIM.LAST_NAME],
        victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
        injuryCode:
          String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
            ? victim[VICTIM.INJURY_POST_KEY]
            : 0,
        qualityVictim: victim[VICTIM.QUALITY_KEY],
        classVictim: victim[VICTIM.CLASS_KEY],
        Town: victim[VICTIM.CITY],
        isExcluded: false,
        gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
        Complement: victim[VICTIM.ADDRESS],
        isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1,
        setDefaultBirthDate,
        cspCode: get(
          get(listings, 'Profession', []).find(
            (el: any) => el.ItemKey === victim.professionCode,
          ),
          'ItemGroup',
          null,
        ),
        itt: parseFloat((victim[VICTIM.ITT] as unknown) as string),
      };
    });
  return {
    details: {
      claim: {
        ...claim,
        [CLAIM.POLICY_NUMBER]: get(policyInfo, 'sagis.policy.policyNumber', ''),
        updatedBy: currentUserStorage.get().username,
        [CLAIM.AUTHORITY_TYPE]: !isEmpty(get(claim, [CLAIM.AUTHORITY_TYPE]))
          ? get(claim, [CLAIM.AUTHORITY_TYPE])
          : null,
        [CLAIM.AUTHORITY_NAME]: !isEmpty(get(claim, [CLAIM.AUTHORITY_NAME]))
          ? get(claim, [CLAIM.AUTHORITY_NAME])
          : null,
        [CLAIM.OPENING_TYPE]: OPENING_TYPE.USAGE,
        [CLAIM.OPENING_STATE]: OPENING_STATE.COMPLETED,
        [CLAIM.STATUS]: CLAIM_STATUS.VALIDATED,
        [CLAIM.CIN]: get(policyInfo, 'sagis.policy.CIN', ''),
        fraudInfo:
          featureService.hasFeature(FEATURES.FRAUD_INFO) &&
          claim[CLAIM.SUSPICIOUS] === CHOICE.YES
            ? {
                ...fraudInfo,
              }
            : undefined,
        [CLAIM.FIRM_REFERENCE]: get(claim, [CLAIM.FIRM_REFERENCE], null),

        priorityReasonId: addPriorityReasonProfession(
          null as any,
          !!victims.find((v: any) =>
            PROFESSION_CODES.includes(v.professionCode),
          ),
          listings,
        )
          ? addPriorityReasonProfession(
              null as any,
              !!victims.find((v: any) =>
                PROFESSION_CODES.includes(v.professionCode),
              ),
              listings,
            )
          : updatePriorityVictim
          ? null
          : undefined,
      },
      victims: !isEmpty(victims)
        ? victims.map((vic: any) => {
            if (vic['injuryPostKey'] !== '2') vic.beneficiaries = [];

            vic.beneficiaries = vic.beneficiaries.map((el: any) => {
              return {
                ...el,
                [BENEFICIARY.FIRST_NAME]: removeWhiteSpaceFromString(
                  get(el, BENEFICIARY.FIRST_NAME, ''),
                ),
                [BENEFICIARY.LAST_NAME]: removeWhiteSpaceFromString(
                  get(el, BENEFICIARY.LAST_NAME, ''),
                ),
                [BENEFICIARY.FRAIS]: isNull(el[BENEFICIARY.FRAIS])
                  ? null
                  : Number(el[BENEFICIARY.FRAIS]),
              };
            });
            return {
              ...vic,
              claimId: claim.id,
              [VICTIM.ITT]: vic.itt === '' ? undefined : vic.itt,
              [VICTIM.ANNUAL_INCOME]:
                vic.annualOfIncome === '' ? undefined : vic.annualOfIncome,
              [VICTIM.IS_EXCLUDED]: vic[VICTIM.IS_EXCLUDED] === CHOICE.YES,
            };
          })
        : [],
      documents: !isEmpty(documents)
        ? documents.map((el: any) => ({
            ...el,
            claimId: claim.id,
          }))
        : documents,
      driver: formattedDriver,
      vehicules: formattedVehicule,

      jurisdictionDegreeId: 1,
      procedureNatureId: 3,
      isTrackingActive: featureService.hasFeature(
        FEATURES.TRACKING_ACTIONS_USER,
      ),
      isInboxesActive: featureService.hasFeature(
        FEATURES.ATTRIBUTION_INBOXES_MANAGER,
      ),
      victimsSagisToAdd: [...formattedSagisVictims],
      victimsSagisToUpdate: [...formattedSagisVictimsToUpdate],
      claimCircumstances: {
        scaleCaseCode: get(claim, 'scaleCaseKey', {}),
        circumstanceCode: get(claim, 'accidentCirconstanceKey', {}),
        responsabilityRate: get(claim, 'responsabilityKey', {}),
        managementMode: MANAGEMENT_MODES.COMMON_RIGHT,
        riskId,
        isFromCorporel: true,
      },
      feeNote: [],
      deletedDocuments: [],
      fraudInfo:
        featureService.hasFeature(FEATURES.FRAUD_INFO) &&
        claim[CLAIM.SUSPICIOUS] === CHOICE.YES
          ? {
              ...fraudInfo,
            }
          : {},
      isLawyerInboxesActive: featureService.hasFeature(FEATURES.LAWYER_INBOXES),
      isCourtCalendarActive: featureService.hasFeature(FEATURES.COURT_CALENDAR),
      opposingPartiesSagisToAdd: !isEmpty(get(opposingParty, 'vehicules', []))
        ? formatOpposingParties(
            opposingParty.vehicules.filter((v: any) => !v.isDeleted && !v.id),
            riskId,
            claim.claimNumber,
            claim.id as any,
            get(listings, 'compagnies', []),
          )
        : [],
      opposingPartiesSagisToUpdate: formattedSagisVehiculesToUpdate,
      riskKey: riskId,
      claimNumber: get(claim, 'claimNumber'),
    },
    claimId: get(claim, 'id'),
  };
};
export const isClaimRejectedOrValidated = (claimDetails: any) => {
  const { claim } = claimDetails;
  return claim &&
    (claim[CLAIM.STATUS] === CLAIM_STATUS.VALIDATED ||
      claim[CLAIM.STATUS] === CLAIM_STATUS.REJECTED)
    ? true
    : false;
};
export const isMixedClaim = (claimDetails: any) => {
  return (
    hasFeature(FEATURES.MIXED_CLAIM) &&
    (claimDetails?.claimType === MATERIAL ||
      (!claimDetails?.doesPVExists &&
        claimDetails?.claimType === CORPOREAL_SAGIS))
  );
};
export const claimStatusLabel = (status: string, props: any) => {
  switch (status) {
    case CLAIM_STATUS.VALIDATED:
      return translate({ ...messages.validatedStatus }, props);
    case CLAIM_STATUS.REJECTED:
      return translate({ ...messages.rejectedStatus }, props);
    case CLAIM_STATUS.PENDING:
      return translate({ ...messages.pendingStatus }, props);
    case CLAIM_STATUS.PENDING_INFO_MODIFICATION:
      return translate({ ...messages.pendingInfoValidation }, props);
    case CLAIM_STATUS.PENDING_APPROVAL:
      return translate({ ...messages.statusPendingApproval }, props);
    default:
      return status;
  }
};

export const findInfoSagisByRegistrationNumber = (
  policyInfo: {
    sagis: {
      claims: {
        code: string;
      }[];
    };
  },
  claims: {
    claim: { claimNumber: string };
  },
) => {
  return (
    policyInfo.sagis &&
    get(policyInfo, 'sagis.claims', []).find(
      (element: { code: string }) => element.code === claims.claim.claimNumber,
    )
  );
};
export const getMoroccanCities = (cities: SagisConfig[]) =>
  cities.filter((city: SagisConfig) => city.ItemGroup === MOROCCO_COUNTRY_CODE);

export const getCities = (cities: SagisConfig[], countryId: string) => {
  let filtredCities: SagisConfig[] = cities.filter(
    city => city.ItemGroup === countryId,
  );
  return filtredCities || ([] as SagisConfig[]);
};

export const getCity = (cities: SagisConfig[], itemKey: string) => {
  if (cities && cities.length)
    return cities.find(city => city.ItemKey === itemKey);
  return {} as SagisConfig;
};

export const cityUtils = { getCities };

export const getCountriesWithCities = (
  countries: SagisConfig[],
  cities: SagisConfig[],
) => {
  return countries.filter(
    (country: SagisConfig) =>
      !isEmpty(cityUtils.getCities(cities, String(country.ItemKey))),
  );
};
export const isClaimClosOrNoAction = (claim: any) => {
  return claim &&
    (get(claim, [CLAIM.STATUS], '').indexOf(CLAIM_STATUS_SAGIS.sansSuite) !==
      -1 ||
      claim[CLAIM.STATUS] === CLAIM_STATUS_SAGIS.clos)
    ? true
    : false;
};
export const shouldDisplayManagerActionDropDown = {
  isClaimRejectedOrValidated,
};

export const shouldDisplayEditButtonClaim = (
  isRecap: boolean,
  isManager: boolean,
  isReadOnly: boolean,
  claimDetails: any,
  isRejected: boolean = false,
  isLawyer: boolean = false,
  isCourtManager: boolean = false,
  isOpeningManager: boolean = false,
) => {
  return (
    (isRecap && !isManager && (!isReadOnly || (isRejected && isLawyer))) ||
    (isRecap && isManager && isClaimPendingClaim(claimDetails)) ||
    (isRecap && isCourtManager) ||
    (isRecap && isOpeningManager && !isRejected)
  );
};
export const shouldDisplayEditButton = (
  isRecap: boolean,
  isManager: boolean,
  isReadOnly: boolean,
  claimDetails: any,
  isRejected: boolean = false,
  isLawyer: boolean = false,
  isCourtManager: boolean = false,
) => {
  return (
    (isRecap &&
      !isManager &&
      (!isReadOnly || (isLawyer && isRejected) || isCourtManager)) ||
    (isRecap && isManager && isClaimPendingClaim(claimDetails)) ||
    (isRecap &&
      userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
      get(claimDetails, 'claim.openingState', null) !=
        OPENING_STATE.NOT_COMPLETED) ||
    (isRecap && userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)) ||
    (isRecap &&
      userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) &&
      featureService.hasFeature(FEATURES.UPDATE_VICTIM_BASIC_MANAGEMENT))
  );
};

export const getListBySagisKey = (
  list: SagisConfig[],
  subList: SagisConfig[],
  roleItemKey: string,
  sagisKey: keyof SagisConfig,
): SagisConfig[] => {
  const itemKey = list.find(ele => ele.ItemKey === roleItemKey)?.ItemKey;

  return subList.filter(ele => ele[sagisKey] === itemKey);
};

export const getSubServices = (
  imagingSubServices: SagisConfig[],
  subServices: CodesConfig[],
) =>
  imagingSubServices.filter(zone =>
    subServices.some(service => service.code === zone.ItemKey),
  );

export const formatAssignmentDetails = (
  claim: AssignmentClaim,
  assignees: Assignees,
  service: string,
  shouldAssignOnSagis: boolean,
  isManager = false,
  feeNoteAmount: [],
  lawyerName: string | undefined,
  claimNumber: string,
  assignedManagerName: string,
): AssignPayload => {
  let assigneesDetail: AssignPayload['assignees'] = {
    assignedLawyer: assignees.lawyer,
    lawyerName,
    managerName: get(currentUserStorage.get(), ['username'], ''),
    assignedSubService: assignees.subService,
    assignedManagerName,
    assignedManagerCode: assignees.assignedManagerCode,
    requestId: get(claim, 'assignment[0].requestId'),
    claimNumber,
    claimId: isManager ? get(claim, 'claimId') : claim.id,
    lawyerAssignmentDate: moment().format(),
  };
  let lawyerAssignmentDetails = {
    contractorFees: [
      {
        uniqueId: uniqueId(),
        contractorTypeCode: service,
        contractorCode: assignees.lawyer as string,
        amount: get(feeNoteAmount, '0.amount', ''),
        isPayment: false,
      },
    ],
    uuid: uuidV4(),
  };

  if (!assignees.lawyer) {
    (lawyerAssignmentDetails as {}) = {};
    assigneesDetail = { ...assigneesDetail, lawyerAssignmentDate: null };
  }

  if (!get(claim, 'assignment[0]')) {
    assigneesDetail = {
      ...assigneesDetail,
      createdAt: moment().format(),
    };
  }
  return {
    claimNumber: claim.claimNumber,
    shouldAssignOnSagis,
    assignees: assigneesDetail,
    lawyerAssignmentDetails,
    ShouldCallfeeNote: true,
  };
};

export const getAssignedJurisdictionLawyerCode = (
  lawyerJurisdiction: any,
  jurisdictionId: number,
  dayOfMonth: number,
) => {
  let lawyerCode = DEFAULT_LAWYER_CODE;
  const mappedLawyersJurisdiction = lawyerJurisdiction.filter(
    (el: any) => el.jurisdictionId === jurisdictionId,
  );
  mappedLawyersJurisdiction.forEach((el: any) => {
    if (!isNaN(dayOfMonth) && el[`day${dayOfMonth}`])
      lawyerCode = el.lawyerCode;
  });
  return lawyerCode;
};

export const formatMultipleAssignmentsDetails = (
  claim: AssignmentClaim,
  assignees: Assignees,
  service: string,
  shouldAssignOnSagis: boolean,
  isManager = false,
  feeNoteAmount: [],
  lawyerName: string | undefined,
  claimNumber: string,
  assignedManagerName: string,
  assignedLawyers: any,
  stackholders: any,
  assignedManagerCode: any,
  oldAssignedLawyers: string[],
): any => {
  let assigneesDetail: AssignPayload['assignees'] = {
    assignedLawyer: assignees.lawyer,
    lawyerName,
    managerName: get(currentUserStorage.get(), ['username'], ''),
    assignedSubService: assignees.subService,
    assignedManagerName,
    assignedManagerCode: assignees.assignedManagerCode,
    requestId: get(claim, 'assignment[0].requestId'),
    claimNumber,
    claimId: isManager ? get(claim, 'claimId') : claim.id,
    lawyerAssignmentDate: moment().format(),
  };
  let lawyerAssignmentDetails = {
    contractorFees: [
      {
        uniqueId: uniqueId(),
        contractorTypeCode: service,
        contractorCode: assignees.lawyer as string,
        amount: get(feeNoteAmount, '0.amount', ''),
        isPayment: false,
      },
    ],
    uuid: uuidV4(),
  };

  if (!assignees.lawyer) {
    (lawyerAssignmentDetails as {}) = {};
    assigneesDetail = { ...assigneesDetail, lawyerAssignmentDate: null };
  }

  if (!get(claim, 'assignment[0]')) {
    assigneesDetail = {
      ...assigneesDetail,
      createdAt: moment().format(),
    };
  }
  return {
    claimNumber: claim.claimNumber,
    shouldAssignOnSagis,
    assignees: assigneesDetail,
    lawyerAssignmentDetails,
    ShouldCallfeeNote: true,
    assignementDetails: {
      contractorFees: assignedLawyers.map((element: any) => ({
        uniqueId: uniqueId(),
        contractorTypeCode: DEFAULT_INTERVENANT_CODE,
        contractorCode: element,
        amount: 0,
        isPayment: false,
        isNew: !oldAssignedLawyers.includes(element),
      })),
      uuid: uuidV4(),
    },
    intervenantSagis: assignedLawyers.map((element: any) => ({
      intervenantTypeCode: DEFAULT_INTERVENANT_CODE,
      intervenantCode: element,
      isNew: !oldAssignedLawyers.includes(element),
    })),
    assignedLawyers: assignedLawyers.map((lawyer: any) => {
      return {
        assignedLawyer: lawyer,
        isNew: !oldAssignedLawyers.includes(lawyer),
        lawyerName: get(
          stackholders.find((e: { ItemKey: string }) => e.ItemKey === lawyer),
          'ItemDescription',
          null,
        ),
        managerName: get(currentUserStorage.get(), ['username'], ''),
        assignedSubService: DEFAULT_SUB_SERVICE_ID,
        assignedManagerName,
        assignedManagerCode: assignedManagerCode,
        claimNumber: claimNumber,
        claimId: isManager ? get(claim, 'claimId') : claim.id,
        lawyerAssignmentDate: moment().format(),
      };
    }),
  };
};
export const getBawabaLawyers = (
  lawyersFromSagis: SagisConfig[],
  users: KeycloakUser[],
) => {
  const usersId = compact(
    users.map(user =>
      user.enabled ? get(user, 'attributes.sagis_code[0]') : undefined,
    ),
  );
  return lawyersFromSagis.filter(lawyer => usersId.includes(lawyer.ItemKey));
};

export const getLawyerById = (list: SagisConfig[], id: string) =>
  list.find(ele => ele.ItemKey === id)?.ItemDescription;

export const formatSagisVehiculeObject = (vehicule: Vehicule) => {
  return {
    firstName: !vehicule[VEHICULE.FIRST_NAME]
      ? '..'
      : vehicule[VEHICULE.FIRST_NAME],
    lastName: !vehicule[VEHICULE.LAST_NAME]
      ? '..'
      : vehicule[VEHICULE.LAST_NAME],
    registrationNumber: get(vehicule, [VEHICULE.REGISTRATION_NUMBER], ''),
    insuranceCompanyCode: get(vehicule, [VEHICULE.OPPOSING_PARTY], ''),
  };
};
export const openingHelper = { formatSagisVehiculeObject };

export const validateRejectionReasons = (decision: any) => {
  if (!decision[REJECTION_DECISION.REJECTION_REASON].has(OTHER_REASON_ID))
    return !decision[REJECTION_DECISION.REJECTION_REASON].size;
  return !decision[REJECTION_DECISION.OTHER_REASON];
};
export const formatVictimPayloadToUpdate = (
  victim: VictimType,
  claimNumber: string,
  riskKey: string,
  updateDecisionVictim: boolean,
  decisionVictim: any,
  listings: any = {},
  updatePriorityVictim: boolean = false,
  priorityReasonClaimId: any = null,
) => {
  if (updateDecisionVictim) {
    return {
      ...victim,
      itt: victim?.itt === '' ? null : victim?.itt,
      updateDecisionVictim: updateDecisionVictim,
      decisionVictim: {
        id: get(decisionVictim, 'id'),
        status: PARTIES_CLAIM_STATUS.PENDING,
        reason: null,
      },
      claimNumbers: claimNumber,
      riskKey: riskKey,
      isTrackingActive: featureService.hasFeature(
        FEATURES.TRACKING_ACTIONS_USER,
      ),
      priorityReasonId: addPriorityReasonProfession(
        priorityReasonClaimId,
        PROFESSION_CODES.includes(victim.professionCode),
        listings,
      )
        ? addPriorityReasonProfession(
            priorityReasonClaimId,
            PROFESSION_CODES.includes(victim.professionCode),
            listings,
          )
        : updatePriorityVictim && priorityReasonClaimId != 4
        ? null
        : undefined,
      victimsSagis: [
        {
          ...victim,
          victimFirstName: victim[VICTIM.FIRST_NAME],
          victimLastName: victim[VICTIM.LAST_NAME],
          victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
          injuryCode:
            String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
              ? victim[VICTIM.INJURY_POST_KEY]
              : 0,
          qualityVictim: victim[VICTIM.QUALITY_KEY],
          classVictim: victim[VICTIM.CLASS_KEY],
          Town: victim[VICTIM.CITY],
          cspCode: get(
            get(listings, 'Profession', []).find(
              (el: any) => el.ItemKey === victim.professionCode,
            ),
            'ItemGroup',
            null,
          ),
          isExcluded: false,
          gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
          Complement: victim[VICTIM.ADDRESS],
          isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1,
          itt:
            victim?.itt === ''
              ? null
              : parseFloat((victim[VICTIM.ITT] as unknown) as string),
        },
      ],
    };
  } else {
    return {
      ...victim,
      updateDecisionVictim: updateDecisionVictim,
      claimNumbers: claimNumber,
      riskKey: riskKey,
      isTrackingActive: featureService.hasFeature(
        FEATURES.TRACKING_ACTIONS_USER,
      ),
      priorityReasonId: addPriorityReasonProfession(
        priorityReasonClaimId,
        PROFESSION_CODES.includes(victim.professionCode),
        listings,
      )
        ? addPriorityReasonProfession(
            priorityReasonClaimId,
            PROFESSION_CODES.includes(victim.professionCode),
            listings,
          )
        : updatePriorityVictim && priorityReasonClaimId != 4
        ? null
        : undefined,
      victimsSagis: [
        {
          ...victim,
          victimFirstName: victim[VICTIM.FIRST_NAME],
          victimLastName: victim[VICTIM.LAST_NAME],
          victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
          cspCode: get(
            get(listings, 'Profession', []).find(
              (el: any) => el.ItemKey === victim.professionCode,
            ),
            'ItemGroup',
            null,
          ),
          gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
          injuryCode:
            String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
              ? victim[VICTIM.INJURY_POST_KEY]
              : 0,
          qualityVictim: victim[VICTIM.QUALITY_KEY],
          classVictim: victim[VICTIM.CLASS_KEY],
          Town: victim[VICTIM.CITY],
          isExcluded: false,
          Complement: victim[VICTIM.ADDRESS],
          isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1,
          itt: parseFloat((victim[VICTIM.ITT] as unknown) as string),
        },
      ],
    };
  }
};

export const formatNextOfKinsToAddOpening = (
  beneficiaries: BeneficiaryType[],
) => {
  if (!isEmpty(beneficiaries)) {
    return beneficiaries.map((el: any) => {
      return {
        fullName: `${removeWhiteSpaceFromString(
          el.firstName,
        )} ${removeWhiteSpaceFromString(el.lastName)}`,
        qualityCode: Number(el.beneficiaryType),
        age: Number(el.age),
        birthDate: el?.dateOfBirth,
        funeralFees: el.funeralFees,
        nextOfKinKey: !isNil(get(el, 'nextOfKinKey'))
          ? get(el, 'nextOfKinKey')
          : undefined,
        handicapIndicator: el.handicapIndicator ? 'Y' : 'N',
        dependentIndicator: el.dependentIndicator ? 'Y' : 'N',
      };
    });
  } else {
    return [];
  }
};
export const formatNextOfKinsToAdd = (
  beneficiaries: BeneficiaryType[],
  victimKey?: string,
) => {
  if (!isEmpty(beneficiaries)) {
    return beneficiaries.map((el: any) => {
      return {
        victimKey: victimKey ? victimKey : undefined,
        ayantDroit: {
          fullName: `${removeWhiteSpaceFromString(
            el.firstName,
          )} ${removeWhiteSpaceFromString(el.lastName)}`,
          qualityCode: Number(el.beneficiaryType),
          age: Number(el.age),
          birthDate: el?.dateOfBirth,
          funeralFees: el.funeralFees,
          nextOfKinKey: !isNil(get(el, 'nextOfKinKey'))
            ? get(el, 'nextOfKinKey')
            : undefined,
          victimKey: victimKey ? victimKey : undefined,
          handicapIndicator: el.handicapIndicator ? 'Y' : 'N',
          dependentIndicator: el.dependentIndicator ? 'Y' : 'N',
        },
      };
    });
  } else {
    return [];
  }
};
export const formatVictimPayloadToInsert = (
  victim: VictimType,
  claimNumber: string,
  riskKey: string,
  responsibilityRate: string,
  listings: any,
) => {
  let setDefaultBirthDate = false;
  if (isEmpty(victim[VICTIM.DATE_OF_BIRTH])) {
    setDefaultBirthDate = true;
  }
  return {
    ...victim,
    claimNumbers: claimNumber,
    riskKey: riskKey,
    isTrackingActive: featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER),
    victimsSagis: [
      String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
        ? {
            ...victim,
            victimFirstName: victim[VICTIM.FIRST_NAME],
            victimLastName: victim[VICTIM.LAST_NAME],
            victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
            injuryCode: victim[VICTIM.INJURY_POST_KEY],
            annualInCome: victim[VICTIM.ANNUAL_INCOME],
            qualityVictim: victim[VICTIM.QUALITY_KEY],
            classVictim: victim[VICTIM.CLASS_KEY],
            Town: victim[VICTIM.CITY],
            responsibilityShare: responsibilityRate,
            responsibilityRate: responsibilityRate,
            isExcluded: false,
            cspCode: get(
              get(listings, 'Profession', []).find(
                (el: any) => el.ItemKey === victim.professionCode,
              ),
              'ItemGroup',
              null,
            ),
            gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
            setDefaultBirthDate,
            Complement: victim[VICTIM.ADDRESS],
            isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1,
            itt: parseFloat((victim[VICTIM.ITT] as unknown) as string),
            nextOfKins:
              String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
                ? formatNextOfKinsToAddOpening(get(victim, 'beneficiaries', []))
                : [],
          }
        : {
            ...victim,
            victimFirstName: victim[VICTIM.FIRST_NAME],
            victimLastName: victim[VICTIM.LAST_NAME],
            victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
            injuryCode: 0,
            responsibilityShare: responsibilityRate,
            responsibilityRate: responsibilityRate,
            qualityVictim: victim[VICTIM.QUALITY_KEY],
            classVictim: victim[VICTIM.CLASS_KEY],
            Town: victim[VICTIM.CITY],
            isExcluded: false,
            cspCode: get(
              get(listings, 'Profession', []).find(
                (el: any) => el.ItemKey === victim.professionCode,
              ),
              'ItemGroup',
              null,
            ),
            setDefaultBirthDate,
            gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
            Complement: victim[VICTIM.ADDRESS],
            isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1,
            itt: parseFloat((victim[VICTIM.ITT] as unknown) as string),
          },
    ],
  };
};

export const isClaimPendingClaim = (claimDetails: any) => {
  const { claim } = claimDetails;
  let decisionVictims: any = [];
  let decisionVehicles: any = [];
  if (!isEmpty(claimDetails?.victims)) {
    claimDetails?.victims.map(
      // eslint-disable-next-line array-callback-return
      (element: any) => {
        !isEmpty(element?.decision) &&
        element?.decision.status === PARTIES_CLAIM_STATUS.PENDING
          ? decisionVictims.push(true)
          : decisionVictims.push(false);
      },
    );
  }
  if (!isEmpty(claimDetails?.vehicules)) {
    claimDetails?.vehicules.map(
      // eslint-disable-next-line array-callback-return
      (element: any) => {
        !isEmpty(element?.decision) &&
        element?.decision.status === PARTIES_CLAIM_STATUS.PENDING
          ? decisionVehicles.push(true)
          : decisionVehicles.push(false);
      },
    );
  }
  return claim &&
    (claim[CLAIM.STATUS] === CLAIM_STATUS.PENDING ||
      claim[CLAIM.STATUS] === CLAIM_STATUS.PENDING_APPROVAL) &&
    !decisionVehicles.includes(true) &&
    !decisionVictims.includes(true)
    ? true
    : false;
};

export const isPendingCompletionUsageClaim = (claim: ClaimType) => {
  return claim &&
    claim[CLAIM.OPENING_TYPE] === OPENING_TYPE.USAGE &&
    claim[CLAIM.OPENING_STATE] === OPENING_STATE.COMPLETED &&
    claim[CLAIM.STATUS] === CLAIM_STATUS.PENDING
    ? true
    : false;
};
export const isNotCompletedClaim = (claim: ClaimType) => {
  return claim &&
    claim[CLAIM.OPENING_TYPE] === OPENING_TYPE.USAGE &&
    claim[CLAIM.OPENING_STATE] === OPENING_STATE.NOT_COMPLETED
    ? true
    : false;
};
const isDayEven = (lossDate: string) => {
  const currentDate = new Date(lossDate);
  const day = currentDate.getDate();
  if (day % 2 === 0) return true;
  return false;
};

export const resolveAssignedManager = (townCode: string, lossDate: string) => {
  if (townCode === '83' && isDayEven(lossDate)) {
    return 2; // assigned manager id
  }
  for (const prop in ManagerToTownCode) {
    if (ManagerToTownCode[prop].includes(Number(townCode))) {
      return Number(prop);
    }
  }
  return 13;
};
export const formattedAssignementClaim = (payload: any, openedClaim: any) => {
  return payload.isOpeningManager
    ? {
        ...payload,
        assignees: {
          ...payload.assignees,
          claimId: get(openedClaim, 'data.data.[0].claimId'),
        },
        assignedLawyers: get(payload, 'assignedLawyers', []).map((el: any) => ({
          ...el,
          claimId: get(openedClaim, 'data.data.[0].claimId'),
        })),
      }
    : payload;
};

export const isJudiciaryStepAssignmentValid = (
  judgementAdd: any,
  judgementOnMerits: any,
  assignedLawyers: SagisConfig[],
) => {
  const assignedLawyerCode =
    get(judgementAdd, 'status') === PROCEDURE_STATUSES.PENDING ||
    get(judgementAdd, 'status') === PROCEDURE_STATUSES.REJECTED
      ? get(judgementAdd, 'lawyerCode')
      : get(judgementOnMerits, 'judgementOnMerits.status') ===
          PROCEDURE_STATUSES.PENDING ||
        get(judgementOnMerits, 'judgementOnMerits.status') ===
          PROCEDURE_STATUSES.REJECTED
      ? get(judgementOnMerits, 'judgementOnMerits.lawyerCode')
      : '';

  return (
    (get(judgementAdd, 'status') === PROCEDURE_STATUSES.PENDING ||
      get(judgementAdd, 'status') === PROCEDURE_STATUSES.REJECTED ||
      get(judgementOnMerits, 'judgementOnMerits.status') ===
        PROCEDURE_STATUSES.PENDING ||
      get(judgementOnMerits, 'judgementOnMerits.status') ===
        PROCEDURE_STATUSES.REJECTED) &&
    !assignedLawyers.map((el: any) => el?.ItemKey).includes(assignedLawyerCode)
  );
};

export const isLossDateValid = (
  lossDate: string,
  policyInfo: any,
  isClaimExist: boolean,
) => {
  const lossDateValue = new Date(lossDate);
  const policyStartDate = new Date(get(policyInfo, 'sagis.policy.initialDate'));
  const policyEndDate = new Date(get(policyInfo, 'sagis.policy.endDate'));
  return (
    lossDateValue >= policyStartDate &&
    lossDateValue <= policyEndDate &&
    !isClaimExist
  );
};

export const resolveLossDateValidationMessage = (
  foundClaims: any,
  props: any,
) => {
  if (
    !isEmpty(get(foundClaims, 'corporeal', [])) &&
    !isEmpty(
      get(foundClaims, 'sagis.claims', []).find(
        (el: any) => el.claimType === CLAIM_TYPE.CORPOREL,
      ),
    )
  ) {
    return {
      message: translate(
        { ...messages.lossDateValidationMessageSagisCorpo },
        props,
      ),
      disable: true,
    };
  } else if (
    isEmpty(get(foundClaims, 'corporeal', [])) &&
    !isEmpty(
      get(foundClaims, 'sagis.claims', []).find(
        (el: any) => el.claimType === 'Materiel',
      ),
    )
  ) {
    return {
      message: translate(
        { ...messages.lossDateValidationMessageSagisMateriel },
        props,
      ),
      disable: true,
    };
  } else if (
    isEmpty(get(foundClaims, 'corporeal', [])) &&
    !isEmpty(get(foundClaims, 'sagis.claims', []))
  ) {
    return {
      message: translate(
        { ...messages.lossDateValidationMessageSagisMixte },
        props,
      ),
      disable: true,
    };
  } else if (isEmpty(get(foundClaims, 'sagis', [])) && !isEmpty(foundClaims)) {
    return {
      message: translate(
        { ...messages.lossDateValidationMessagePolicy },
        props,
      ),
      disable: true,
    };
  } else if (
    !isEmpty(
      get(foundClaims, 'corporeal', []).filter(
        (el: any) => el.status != CLAIM_STATUS.REJECTED,
      ),
    ) &&
    !isEmpty(foundClaims) &&
    isEmpty(get(foundClaims, 'sagis.claims', []))
  ) {
    return {
      message: translate(
        { ...messages.lossDateValidationMessageCorporealPending },
        props,
      ),
      disable: true,
    };
  } else if (
    !isEmpty(
      get(foundClaims, 'corporeal', []).filter(
        (el: any) => el.status === CLAIM_STATUS.REJECTED,
      ),
    ) &&
    !isEmpty(foundClaims) &&
    isEmpty(get(foundClaims, 'sagis.claims', []))
  ) {
    return {
      message: translate(
        { ...messages.lossDateValidationMessageCorporealRejected },
        props,
      ),
      disable: false,
    };
  }
};

export const displayErrorInputCin = (
  data: any,
  victim: VictimType,
  dataClaimToUpdate: any,
) => {
  return (
    checkUniqCinVictim(
      [
        ...get(dataClaimToUpdate, 'victims', []).filter(
          (el: any) => Number(el.id) != get(victim, 'id'),
        ),
      ],
      get(victim, [VICTIM.CIN]),
      get(victim, 'id') as any,
      moment(get(dataClaimToUpdate, 'claim.lossDate')).format('YYYY-MM-DD'),
    ) &&
    !isMinorVictim(
      victim,
      moment(get(dataClaimToUpdate, 'claim.lossDate')).format('YYYY-MM-DD'),
    )
  );
};

export const isActivateOpenClaimSagis = (
  appConfigList: appConfigListingTyping[],
) => {
  return Boolean(
    Number(
      get(
        appConfigList?.find(
          (item: appConfigListingTyping) =>
            item.task === 'ACTIVATE_OPEN_CLAIM_SAGIS',
        ),
        'value',
        0,
      ),
    ),
  );
};
